import backend from "../../../backend/backend";
import label from "../../../i18n/label";
import Notify from "../../shared/Notify";
import McpPlaygroundActions from "./mcpPlaygroundActions";

export const loadMcpPlaygrounds = (intl, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getPlaygrounds()
      .then((data) => {
        console.log("loaded  mcp playgrounds", data);
        dispatch({
          type: McpPlaygroundActions.LIST_LOADED,
          playgrounds: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load mcp playgrounds", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const deleteMcpPlayground = (intl, uid, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .deletePlayground(uid)
      .then((data) => {
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to delete mcp playground", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
